import { render, staticRenderFns } from "./custom-dialog.vue?vue&type=template&id=495f8abd&"
import script from "./custom-dialog.vue?vue&type=script&lang=js&"
export * from "./custom-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports